import Vue from 'vue'
import grid from './grid.vue'
import edit from './edit.vue'
import select from './select.vue'

Vue.component('app-acessofuncionalidade-grid', grid)
Vue.component('app-acessofuncionalidade-edit', edit)
Vue.component('app-acessofuncionalidade-select', select)
